import { useLocation } from 'react-router-dom';
import { CourseGridSkeleton } from '../features/courses/components/CourseGridSkeleton.jsx';
import { isNativePlatform } from '../services/native/platformService.js';
import { Text } from '../ui/Text.jsx';

export function PageLoading() {
  const { pathname } = useLocation();
  // Native startup already coordinates its own loading screen and splash.
  if (isNativePlatform()) return null;

  const path = pathname.replace(/\/+$/, '') || '/';
  const isCourseCollection = ['/', '/courses', '/assessments', '/mycourse', '/mydashboard'].includes(path);

  return (
    <div>
      <div className="mb-6" aria-hidden="true">
        <Text variant="eyebrow">
          <span className="inline-block h-3 w-14 rounded-full bg-skeleton animate-pulse motion-reduce:animate-none" />
        </Text>
        <Text variant="h2" as="div" className="mt-2">
          <span className="block h-[1.05em] w-60 max-w-full rounded-input bg-skeleton animate-pulse motion-reduce:animate-none" />
        </Text>
      </div>

      {isCourseCollection ? (
        <CourseGridSkeleton label="Loading page" />
      ) : (
        <div role="status" aria-label="Loading page" aria-busy="true">
          <span className="sr-only">Loading page…</span>
          <div aria-hidden="true" className="space-y-5 rounded-card border border-line p-6">
            <div className="h-40 rounded-input bg-skeleton-soft animate-pulse motion-reduce:animate-none" />
            <div className="h-5 w-3/4 rounded-input bg-skeleton animate-pulse motion-reduce:animate-none" />
            <div className="h-5 w-1/2 rounded-input bg-skeleton animate-pulse motion-reduce:animate-none" />
          </div>
        </div>
      )}
    </div>
  );
}
